"use strict";
/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
(self["webpackChunksanposaki"] = self["webpackChunksanposaki"] || []).push([["src_cart_js"],{

/***/ "./src/cart.js":
/*!*********************!*\
  !*** ./src/cart.js ***!
  \*********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export */ __webpack_require__.d(__webpack_exports__, {\n/* harmony export */   initCart: () => (/* binding */ initCart)\n/* harmony export */ });\nfunction initCart() {\n  const minusButton = document.querySelector('button[name=\"minus\"]');\n  const plusButton = document.querySelector('button[name=\"plus\"]');\n  const quantityInput = document.getElementById('Quantity');\n\n  minusButton.addEventListener('click', function () {\n    quantityInput.stepDown();\n  });\n\n  plusButton.addEventListener('click', function () {\n    quantityInput.stepUp();\n  });\n}\n\n\n//# sourceURL=webpack://sanposaki/./src/cart.js?");

/***/ })

}]);